import { FiSearch } from 'react-icons/fi'

const Search = ({searchText, handleChangeSearchText}) => {
    return (
        <div className="relative flex text-nt-blue mb-5">
            <FiSearch className="absolute left-[10px] top-1/2 -translate-y-1/2 pointer-events-none" />
            <input key={"search_input"} type="text" placeholder="Search" value={searchText} onChange={(e) => handleChangeSearchText(e.target.value)} className="w-full rounded bg-nt-grey-light py-1.5 pl-10 pr-2.5 text-inherit border-0 outline-none focus:ring-2 focus:ring-nt-blue/20" />
        </div>
    )
}

export default Search
